var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { ButtonTabNavigatorButtons } from "@nitra/nkmb-card-components/components/tabNavigationWithButtons/ButtonTabNavigatorButtons";
import { Redirect } from "@nitra/nkmb-card-components/utils";
import { Route, Routes } from "react-router-dom";
export function ButtonTabNavigatorWithRouter(props) {
    var _a;
    var tabs = props.tabs;
    return (_jsxs(Box, __assign({ sx: __assign({ width: "100%", display: "flex", flexDirection: "column" }, props.sx) }, { children: [_jsx(ButtonTabNavigatorButtons, { tabs: tabs, blackVersion: props.blackVersion, replaceLastPath: props.replaceLastPath, replaceLastPathOneDot: props.replaceLastPathOneDot }), _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Redirect, { to: tabs[(_a = props.defaultRouteIndex) !== null && _a !== void 0 ? _a : 0].path }) }), tabs.map(function (tab) {
                        return _jsx(Route, { path: tab.path, element: tab.component }, tab.path);
                    })] })] })));
}
